import React, { useContext, useEffect, useState } from 'react';
import Select from "react-select";
import { Icon } from '@iconify/react';
import { ToastContainer, toast } from 'react-toastify'
import { AddSessionApi, CalendarOfSittingsAdd, GetConstituency, GetConstituencyMaped, GetKlaListForSearchFilter, GetMemberList, GetMemberMappingList, GetRole, GetSalutation, MemberMappinAdd, MemberMappingBySession, MemberMappingEdit } from '../../Services/allApi';
import DatePicker from 'react-datepicker';
import PopOver from '../../Components/PopOver';
import InfoIcon from '../../Components/InfoIcon'

// Custom option component
const CustomOption = (props) => {
    const { innerRef, innerProps, data } = props;
    const parts = data.label.split(" ");
    const constituency = parts[0];
    const coNo = parts[1];
    const reserved = parts[2]
    const desc = parts[3]

  
    return (
        <div ref={innerRef} {...innerProps} className="custom-option">
        <div className="flex flex-row gap-2 w-full border border-blue-gray-300 bg-gray-100 mb-2 hover:bg-gray-300 cursor-pointer ">
          <div className="w-4/12 flex-1 flex p-1 border-r border-gray-300">{constituency}</div>
          <div className=" p-1 border-r border-gray-300 w-6 ">{coNo}</div>
          <div className=" p-1 border-r border-gray-300 w-2/12">{reserved}</div>
          <div className=" p-1 items-start justify-start flex flex-col w-5/12  ">{desc}</div>
        </div>
      </div>
    );
  };
  
  // Custom styles for the select component
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
    }),
    menu: (provided) => ({
      ...provided,
      width: '1000px',
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '5px 10px',
    }),
    control: (baseStyles, state) => ({
        ...baseStyles,
        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
        height: '2rem',
        borderRadius: '0.5rem',
    }),
  };

function EditMemberMapping({detailsTable,handleCloseModal}) {
    const [videoDetailsArray, setVideoDetailsArray] = useState([]);
    const [sessionList, setSessionList] = useState([])
    const [memberList, setMemberList] = useState([])
    const [constituencyList, setconstituencyList] = useState([])
    const [saluationtList, setSaluationtList] = useState([])
    const [roleList, setRoleList] = useState([])

    const [inputType,setinputType]=useState('text')
    // const [VideoInitialDetails, setVideoInitialDetails] = useState({
    //     startDate: null,
    //     endDate: null,
    //     kla: null,
    //     video_session: null,
    // });

    const [SessionIdAfterConnected,setSessionIdAfterConnected]=useState()
    // member mapping logic starts
    const [formData, setFormData] = useState({
        member: null,
        constituency: null,
        salutation: null,
        role: null,
        designation: '',
        mal_designation:'',
        session:SessionIdAfterConnected

    });

    const [formList, setFormList] = useState([]);

    const handleInputChangeMM = (field, value) => {
        setFormData({
            ...formData,
            [field]: value
        });
    };

    const handleAddForm = () => {
        if (formData.member && formData.constituency && formData.role && formData.salutation) {
            setFormList([formData,...formList]);
            setFormData({
                member: null,
                constituency: null,
                salutation: null,
                role: null,
                designation: '',
                mal_designation:'',
                session:SessionIdAfterConnected
            });
        }
        else {
            toast.warning("Fill the form completely to add")
        }
     
    };

    const handleInputChangeList = (index, field, value) => {
        const newFormList = [...formList];
        newFormList[index][field] = value;
        setFormList(newFormList);
    };

    const handleRemoveForm = (index) => {
        const newFormList = formList.filter((_, i) => i !== index);
        setFormList(newFormList);
    };

    const handleSubmitMM = async() => {
        const token=sessionStorage.getItem('access_token')
        console.log("token=",token)
        const reqHeader = {
         "Content-Type": "application/json",
         "Authorization": `${token}`
     };
            // console.log(JSON.stringify(formList, null, 2));
            
            var modifiedFormList = formList?.map(item => ({
                member: item.member.value,
                constituency: item.constituency.value,
                salutation: item.salutation.value,
                role: item.role.value,
                designation: item.designation,
                mal_designation:item.mal_designation,
                id: item?.id || ''
                // session: SessionIdAfterConnected
            }));
            
            // Create an object with the session_id
            // const sessionObj = { session_id: detailsTable.session_id };
            
            // Add session_id as the first element in the modifiedFormList array
            // modifiedFormList.unshift(sessionObj);
            

            
            console.log(JSON.stringify(modifiedFormList, null, 2));

              
        const res=await MemberMappingEdit(modifiedFormList,reqHeader,detailsTable.session_id)
        console.log(res);
        if(res?.data?.code==200){
            alert("Member mapping successfull")
            handleCloseModal()
        }
        else{
            alert(res?.response?.data?.message)
        }
        
        // console.log(res);
        
    }

    // member mapping ends

    
    // get Member list
    const MemberListCallApi = async () => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const resultMember = await GetMemberList();
            // console.log(resultMember);
            setMemberList(resultMember?.data?.data)
        } catch (error) {
            console.error("Error fetching Member list for filter:", error);
        }
    }


    useEffect(() => {
        MemberListCallApi();
    }, []);

    // member dropdown
    const memberoptions = memberList?.map((item, index) => ({
        value: item.member_id,
        label: `${item.member_name}`,
        valuefrosearch: item.member_id

    }));

    
    // get Constituency list
    const ConstutencyListApi = async () => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const SID=detailsTable?.session_id
            const resultConstituency = await GetConstituencyMaped(SID);
            console.log(resultConstituency);
            setconstituencyList(resultConstituency?.data?.data)
        } catch (error) {
            console.error("Error fetching constituency list :", error);
        }
    }


    useEffect(() => {
        ConstutencyListApi();
    }, []);

    // constituency dropdown
    const constituencyOptions = constituencyList?.map((item, index) => ({
        value: item.id,
        label: `${item?.constituency_name} ${item?.constituency_no} ${item?.reservation} ${item?.constituency_description}`,
        valuefrosearch: item.id

    }));

    // get salutation list
    const SalutationListApi = async () => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const resultsalute = await GetSalutation();
            // console.log(resultsalute);
            setSaluationtList(resultsalute?.data?.data)
        } catch (error) {
            console.error("Error fetching salutation list :", error);
        }
    }


    useEffect(() => {
        SalutationListApi();
    }, []);

    // salutation dropdown
    const saluteoptions = saluationtList?.map((item, index) => ({
        value: item.id,
        label: `${item.salutation_name}`,
        valuefrosearch: item.id

    }));


     // get role list
     const RoleListApi = async () => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const resultrole= await GetRole();
            // console.log(resultrole);
            setRoleList(resultrole?.data?.data)
        } catch (error) {
            console.error("Error fetching role list :", error);
        }
    }


    useEffect(() => {
        RoleListApi();
    }, []);

    // salutation dropdown
    const roleoptions = roleList?.map((item, index) => ({
        value: item.role_id,
        label: `${item.role_name}`,
        valuefrosearch: item.role_id

    }));
     
    useEffect(()=>{
        memberMappingList()
    },[])
    // member mapping list
    const memberMappingList=async()=>{
        const token=sessionStorage.getItem('access_token')
        const reqHeader = {
         "Content-Type": "application/json",
         "Authorization": `${token}`
     };
     const curentSession=detailsTable?.session_id
        const res=await MemberMappingBySession({session_id:curentSession},reqHeader)
        setFormList(res?.data?.data)
        console.log(res);
    }
    const [isDesgSelected,setIsDesgSelected]=useState('')
    const handleDesgClick=()=>{
        setIsDesgSelected('d')
    }
    const handleDesgMalClick=()=>{
        setIsDesgSelected('dm')
    }
    return (
        <>
            <div className='flex w-full h-full flex-row' style={{ height: '86vh',fontFamily:'ropa sans' }}>

                    <div className='w-full flex items-center flex-col overflow-y-scroll overflow-x-hidden' style={{ height: '87vh' }}>
                    <div className='flex justify-end items-start w-full pb-1'><div onClick={handleCloseModal} className='flex justify-center items-center h-8 w-14 rounded border border-red-500 hover:bg-red-500 hover:text-white transform duration-500 ease-in-out cursor-pointer text-red-500'><Icon icon="iconamoon:close" className='text-2xl' /></div></div>

                        <div className='flex flex-row justify-center flex-wrap ms-5 me-5 gap-1 w-full '>
                            <div className='flex flex-col w-full gap-2'> 

                            <div className='bg-success px-4 py-2 rounded border'>
                                    <h3 className='text-blue-700 text-xl font-bold mb-4 text-center'>Presetted details </h3>
                                    <div className='flex flex-row justify-between  items-centerflex-wrap mb-4'>

                                    <div className='flex flex-row w-48 h-10 justify-center items-center rounded-lg bg-gray-300 border border-dashed border-blue-500 '><p>KLA: {detailsTable.kla}</p></div>
                                    <div className='flex flex-row w-48 h-10 justify-center items-center rounded-lg bg-gray-300 border border-dashed border-blue-500 '><p>Session: {detailsTable.session_no}</p></div>
                                    <div className='flex flex-row w-48 h-10 justify-center items-center rounded-lg bg-gray-300 border border-dashed border-blue-500 '><p>Start date: {detailsTable.session_start_date}</p></div>
                                    <div className='flex flex-row w-48 h-10 justify-center items-center rounded-lg bg-gray-300 border border-dashed border-blue-500 '><p>End date: {detailsTable.session_end_date}</p></div>

                                    </div>
                                    
                                </div>

                                <div className='bg-success px-4 py-2 rounded border'>
                                    <h3 className='text-blue-700 text-xl font-bold mb-4 text-center'>Enter details </h3>
                                     
                                    <div className='flex flex-row justify-between flex-wrap mb-5'>

                                    <div className={`flex flex-col ${isDesgSelected=='d'||isDesgSelected=='dm'?'w-32':'min-w-48'}`}>
                                    <label>Existing Constituency</label>
                                            <Select
                                                options={constituencyOptions}
                                                value={formData.constituency}
                                                onChange={option => handleInputChangeMM('constituency', option)}
                                                styles={customStyles}
                                                components={{ Option: CustomOption }}
                                                
                                            />
                                        </div>
 
                                        <div className={`flex flex-col ${isDesgSelected=='d'||isDesgSelected=='dm'?'w-32':'min-w-48'}`}>
                                            <label>Existing Salutation</label>
                                            <Select
                                                options={saluteoptions}
                                                value={formData.salutation}
                                                onChange={option => handleInputChangeMM('salutation', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>

                                        <div className={`flex flex-col ${isDesgSelected=='d'||isDesgSelected=='dm'?'w-32':'min-w-48'}`}>
                                            <label>Existing Members</label>
                                            <Select
                                                options={memberoptions}
                                                value={formData.member}
                                                onChange={option => handleInputChangeMM('member', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>


                                        <div className={`flex flex-col ${isDesgSelected=='d'||isDesgSelected=='dm'?'w-32':'min-w-48'}`}>
                                        <label>Existing Role</label>
                                            <Select
                                                options={roleoptions}
                                                value={formData.role}
                                                onChange={option => handleInputChangeMM('role', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>

                                        <div className={`flex flex-col ${isDesgSelected=='d'?'min-w-96':isDesgSelected=='dm'?'min-w-20':'min-w-48'}`}>
                                        <label className='flex flex-row gap-1 items-center'><span>Designation</span><InfoIcon content={"Enter all designation seperated by , (comma) "} /></label>
                                            <input
                                                type="text"
                                                value={formData.designation}
                                                placeholder="use , to seperate multiple"
                                                onFocus={handleDesgClick}
                                                onBlur={()=>setIsDesgSelected('')}
                                                onChange={(e) => handleInputChangeMM('designation', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className={`flex flex-col ${isDesgSelected=='dm'?'min-w-96':isDesgSelected=='d'?'min-w-20 ':'min-w-48'}`}>
                                        <label className='flex flex-row gap-1 items-center'><span>Designation Malayalam</span><InfoIcon content={"Enter all designation in malayalam seperated by , (comma) "} /></label>
                                            <input
                                                type="text"
                                                value={formData.mal_designation}
                                                onFocus={handleDesgMalClick}
                                                onBlur={()=>setIsDesgSelected('')}
                                                placeholder="use , to seperate multiple"
                                                onChange={(e) => handleInputChangeMM('mal_designation', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                    </div>
                                    <div className='w-full flex justify-center items-center'>
                                        <div className='w-2/12 '>
                                            <button className='w-full py-2 rounded-full bg-green-500 hover:bg-green-600 text-white mb-3' onClick={handleAddForm}>
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='w-full flex flex-col gap-2 mt-2'>
                            {formList?.map((form, index) => (
                                <div key={index} className='bg-gray-200 px-4 rounded border'>
                                    <h3 className='text-gray-700 text-sm text-left'>No {index + 1}</h3>

                                    <div className='flex flex-row justify-between flex-wrap mb-3'>

                                    <div className='flex flex-col min-w-44'>
                                            <label>Constituency</label>
                                            <Select
                                                options={constituencyOptions}
                                                value={form.constituency}
                                                onChange={option => handleInputChangeList(index, 'constituency', option)}
                                                styles={customStyles}
                                                components={{ Option: CustomOption }}
                                                
                                            />
                                        </div>

                                        <div className='flex flex-col min-w-44'>
                                            <label>Salutation</label>
                                            <Select
                                                options={saluteoptions}
                                                value={form.salutation}
                                                onChange={option => handleInputChangeList(index, 'salutation', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>

                                        <div className='flex flex-col min-w-44'>
                                            <label>Members</label>
                                            <Select
                                                options={memberoptions}
                                                value={form.member}
                                                onChange={option => handleInputChangeList(index, 'member', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>



                                        <div className='flex flex-col min-w-44'>
                                            <label>Role</label>
                                            <Select
                                                options={roleoptions}
                                                value={form.role}
                                                onChange={option => handleInputChangeList(index, 'role', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>

                                        <div className='flex flex-col min-w-44'>
                                            <label>Designation</label>
                                            <input
                                                type="text"
                                                value={form.designation}
                                                onChange={(e) => handleInputChangeList(index, 'designation', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className='flex flex-col min-w-44'>
                                            <label>Designation malayalam</label>
                                            <input
                                                type="text"
                                                value={form.mal_designation}
                                                onChange={(e) => handleInputChangeList(index, 'mal_designation', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>


                                        <div className='flex flex-col'>
                                            <label className='' style={{ visibility: 'hidden' }}>Designation</label>
                                            <button className='w-full h-10 rounded-full bg-red-500 text-white hover:bg-red-600' onClick={() => handleRemoveForm(index)}>
                                                Remove
                                            </button>
                                        </div>


                                    </div>
                                    
                                </div>
                            ))}
                        </div>

                      <div className='flex justify-center flex-row w-full gap-5'>
                      <div className='w-2/12'><button className='w-full py-2 mt-20 mb-10 text-white rounded-full bg-primary' onClick={handleSubmitMM}>Submit</button></div>
                        <div className='w-2/12'><button className='w-full py-2 mt-20 mb-10 text-red-500 border rounded-full bg-success' onClick={handleCloseModal}>Cancel</button></div>
                      </div>

                    </div>

            </div>

            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default EditMemberMapping;
